import { FC, useState, useEffect, Fragment } from 'react';
import dayjs from 'dayjs';
// Components
import Prizes from 'components/Prizes';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  quizzes: any[];
  prizes: string[];
};

const TextCountdown:FC<Props> = ({ quizzes, prizes }) => {
  const { t } = useTranslation();

  const [ allEnded, setAllEnded ] = useState(false);
  const [ message, setMessage ] = useState<string | null>(null);

  useEffect(() => {
    const now = dayjs();
    const nowMs = Date.now();

    const sortedQuizzes = [...quizzes].sort((a:any, b:any) => Number(a.startsDate) - Number(b.startsDate));

    // Quiz is active if started AND (no endsDate OR endsDate in future)
    const hasActiveQuiz = quizzes.some((q:any) => {
      const start = Number(q.startsDate);
      const end = q.endsDate ? Number(q.endsDate) : null;
      return start <= nowMs && (end === null || end > nowMs);
    });

    // All ended: no active quiz AND every quiz with a valid endsDate is in the past
    const validEnds = quizzes
      .filter((q:any) => q.endsDate)
      .map((q:any) => Number(q.endsDate));

    const ended = !hasActiveQuiz && validEnds.length > 0 && validEnds.every((e:number) => e <= nowMs);
    setAllEnded(ended);

    if ( ended ) {
      setMessage(null);
      return;
    }

    // Find next upcoming quiz (not yet started)
    let nextStartTime = null;
    for ( const quiz of sortedQuizzes ){
      const quizStartDate = dayjs(Number(quiz.startsDate));
      if ( now.isBefore(quizStartDate) ){
        nextStartTime = quizStartDate;
        break;
      }
    }

    if ( nextStartTime ){
      // Some quizzes haven't started yet
      setMessage(t('pages.quizGroup.nextQuizStarts', { date: nextStartTime.format('MMMM D, YYYY') }));
    } else if ( validEnds.length > 0 ){
      // All quizzes started, still active — show when last one ends
      const latestEnd = Math.max(...validEnds);
      setMessage(t('pages.quizGroup.winnersWillBeAnnounced', { date: dayjs(latestEnd).format('MMMM D, YYYY') }));
    } else {
      // All quizzes active with no endsDate — no message
      setMessage(null);
    }
    // eslint-disable-next-line
  }, []);

  if ( allEnded ) return null;

  return (
    <Fragment>
      {message ? <div className="text-primary text-center text-sm mb-4">{message}</div> : null}
      {!!prizes.length ? <Prizes prizes={prizes} /> : null}
    </Fragment>
  );
};

export default TextCountdown;
